// http://157.175.90.166:8080

import HTTP from "../services/http.service";

import Helpers from "../helpers/shared.helper";

var PaciService = {};


PaciService.checkSubmit = (data) => {
    Helpers.debug_payment("OCR check", data);
    let config = {
        method: "get",
        url: `/paci/check_submit?civil_id=${data?.civilId}`,
        // url: "/paci/check_submit?civil_id=278033001516",
        data: data,
    };
    return HTTP(config);
};

PaciService.status = (data) => {
    Helpers.debug_payment("OCR check", data);
    let config = {
        method: "get",
        url: "/paci/status",
        data: data,
        // params: data
    };
    return HTTP(config);
};

export default PaciService;
